import {
    BoundedContent,
    BulletList,
    BulletListContent,
    Column,
    FlexBox,
    GridContainer,
    H2,
    Icon,
    Li,
    P,
    Row,
} from '@vp/swan';
import { __, __image } from '@99designs/i18n';
import { CloudinaryImage } from '../CloudinaryImage';

export const WhyHireOnVistaprint = () => {
    return (
        <BoundedContent paddingTop="6" paddingBottom="5" data-testid="why-vistaprint">
            <GridContainer>
                <Row>
                    <Column span={6} verticallyCenterContent data-testid="why-vistaprint-content">
                        <FlexBox
                            marginX={{ xs: 6, sm: 0 }}
                            flexDirection="column"
                            alignItems={{ xs: 'center', sm: 'start' }}
                        >
                            <H2
                                textAlign={{ xs: 'center', sm: 'left' }}
                                marginBottom="between-subsections"
                            >
                                {__('Why choose VistaPrint?')}
                            </H2>
                            <BulletList data-testid="why-vistaprint-benefits">
                                <Li data-testid="why-vistaprint-benefit-professionals">
                                    <Icon iconType={'ai'} marginRight={4} />
                                    <BulletListContent>
                                        <strong>{__('Leave it to the professionals')}</strong>
                                        <P marginTop={3}>
                                            {__(
                                                'Our global community of vetted, professional designers will create and deliver every pixel-perfect file and format you need.'
                                            )}
                                        </P>
                                    </BulletListContent>
                                </Li>
                                <Li data-testid="why-vistaprint-benefit-budget">
                                    <Icon iconType={'heart'} marginRight={4} />
                                    <BulletListContent>
                                        <strong>{__('Stick to your budget ')}</strong>
                                        <P marginTop={3}>
                                            {__(
                                                'From minor tweaks to complete redesigns – we offer a range of services to grow your brand without breaking the bank.'
                                            )}
                                        </P>
                                    </BulletListContent>
                                </Li>
                                <Li data-testid="why-vistaprint-benefit-support">
                                    <Icon iconType={'liveChat'} marginRight={4} />
                                    <BulletListContent>
                                        <strong>{__('24/7 customer support')}</strong>
                                        <P marginTop={3}>
                                            {__(
                                                'Our Customer Care Team are here to support you with your design or print journey – whenever you need it.'
                                            )}
                                        </P>
                                    </BulletListContent>
                                </Li>
                                <Li data-testid="why-vistaprint-benefit-all-in-one-place">
                                    <Icon iconType={'delivery'} marginRight={4} />
                                    <BulletListContent>
                                        <strong>
                                            {__('Design, print, store, deliver – all in one place')}
                                        </strong>
                                        <P marginTop={3}>
                                            {__(
                                                'All your designs are stored within your VistaPrint account, ready to print onto marketing materials, merch, packaging and more.'
                                            )}
                                        </P>
                                    </BulletListContent>
                                </Li>
                            </BulletList>
                        </FlexBox>
                    </Column>
                    <Column
                        span={6}
                        verticallyCenterContent
                        paddingLeft={{ xs: 0, sm: 8 }}
                        paddingX={{ xs: 10, sm: 0 }}
                        data-testid="why-vistaprint-image"
                    >
                        <FlexBox justifyContent="center" alignItems="center">
                            <CloudinaryImage
                                render={(props) => (
                                    <img
                                        src={props.src}
                                        srcSet={props.srcSet}
                                        alt=""
                                        style={{
                                            maxWidth: '100%',
                                            height: '100%',
                                            maxHeight: '520px',
                                        }}
                                    />
                                )}
                                imagePath={__image(
                                    'expert_services/HubPage/why-hire-on-vistaprint-image'
                                )}
                            />
                        </FlexBox>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};
